/* 🤖 this file was generated by svg-to-ts*/
export const iconAdaptive = {
  name: 'adaptive',
  data: `<svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g filter="url(#filter0_d_1119_519)">
  <g opacity="0.8">
  <circle cx="28.0001" cy="22.9993" r="17.2667" fill="white"/>
  <circle cx="28.0001" cy="22.9993" r="16.5917" fill="white" stroke="white" stroke-opacity="0.3" stroke-width="1.35"/>
  </g>
  </g>
  <path d="M26.9777 32.9122V25.9637H23.0951C22.5551 25.9637 22.1902 25.2924 22.4529 24.7385L27.8242 12.7046C28.1599 11.9158 29.1963 12.2011 29.1963 13.0907V20.123H32.9036C33.4437 20.123 33.794 20.7776 33.5605 21.3314L28.3643 33.2814C28.014 34.0871 26.9777 33.8017 26.9777 32.9122Z" fill="url(#paint0_linear_1119_519)"/>
  <path d="M49 23C49 34.598 39.598 44 28 44C16.402 44 7 34.598 7 23C7 11.402 16.402 2 28 2C39.598 2 49 11.402 49 23ZM11.2 23C11.2 32.2784 18.7216 39.8 28 39.8C37.2784 39.8 44.8 32.2784 44.8 23C44.8 13.7216 37.2784 6.2 28 6.2C18.7216 6.2 11.2 13.7216 11.2 23Z" fill="url(#paint1_linear_1119_519)"/>
  <defs>
  <filter id="filter0_d_1119_519" x="0.833398" y="0.782544" width="54.3334" height="54.3334" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset dy="4.95"/>
  <feGaussianBlur stdDeviation="4.95"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0.427451 0 0 0 0 0.278431 0 0 0 0 0.988235 0 0 0 0.3 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1119_519"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1119_519" result="shape"/>
  </filter>
  <linearGradient id="paint0_linear_1119_519" x1="24.1252" y1="33.0757" x2="39.1644" y2="27.6914" gradientUnits="userSpaceOnUse">
  <stop stop-color="#FF00FF"/>
  <stop offset="0.46" stop-color="#9116F9"/>
  <stop offset="1" stop-color="#3199FF"/>
  </linearGradient>
  <linearGradient id="paint1_linear_1119_519" x1="13.558" y1="42.6723" x2="56.6619" y2="13.2111" gradientUnits="userSpaceOnUse">
  <stop stop-color="#FFB2FF"/>
  <stop offset="0.46" stop-color="#DCB4FE"/>
  <stop offset="1" stop-color="#A4D2FF"/>
  </linearGradient>
  </defs>
  </svg>  
`,
}
